import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { use_effect } from '../_base/use_effect';
import { useToast } from '../use-toast';

export function use_toast_no_related_words(word_english: string) {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { toast, dismiss } = useToast();

  const [toast_id, set_toast_id] = useState('');

  /*
   * EFFECTS
   */

  use_effect(() => {
    return () => dismiss(toast_id);
  }, [toast_id]);

  /*
   * METHODS
   */

  function show() {
    let toast_data = toast({ title: t(i18n_base_ui.toasts.no_related_words.title, { word_english }) });

    set_toast_id(toast_data.id);
  }

  return { show };
}
